<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">How do I manage my shipping label?</h1>

			<p>
				You can manage your shipping label by <a :href="`/account/order.php?item_id=${parseInt($route.params.item_id)}`" class="help-link">clicking on the link</a>.
			</p>

			<ul class="h-ul-gap">
				<li>
					<strong>Until when can I get refund on my shipping label?</strong><br>
					Shipping labels can be refunded if cancelation requested within 30 days of generation.
				</li>

				<li>
					<strong>When will I get my shipping label amount back?</strong><br>
					The processing time is at least 15 days, but no greater than 30 days, after which the funds will return to your balance.
				</li>
				<li>
					<strong>Qualifying refund terms -</strong>
					<ul>
						<li>To qualify, a shipment must not have been scanned by the USPS, or included on a Scan Form.</li>
						<li>Cancelation can not be reversed, you will need to generate new label if you change your mind.</li>
					</ul>
				</li>
			</ul>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "ManageLabel",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>

</style>